// This file should not be a public module until
// we're happy with the API of these utils
// https://git.hubteam.com/HubSpot/foundations-theming/pull/243#issuecomment-10825842

export { useTheme } from './useTheme';
export { css } from './css';
import { styledWithTheme } from './styledWithTheme';
export { withTheme } from './withTheme';
export { isTrellisTheme, isCanvasTheme, isLightTheme, isDarkTheme } from './themeMetadata';
export default styledWithTheme;